import withLayout from "../../layouts/withLayout";
import React, { useMemo } from "react";
import { Mask, Button } from "@t8891/pc";
import { useMutation, useQuery } from "react-query";
import { fakeAgainInquiry, fetchRecommendInquiry } from "@Services/inquiry";
import { IAgainInquiryParams, IRecommendInquiry } from "@Types/business";
import qs from "qs";
import { useSetState } from "ahooks";
import { message } from "antd";
import { host } from "@Services/url";
import AdBySelfRefresh from "@Components/ad/AdBySelfRefresh";
import { postInitialCollect } from "@Services/common";
import { Crumbs } from "@Components/ask/Smallclothes";
import DefaultSuccessItem from "@Components/ask/DefaultSuccessItem";
import AskSuccessLogistic from "@components/InquiryLogistics/AskSuccessLogistic";

export const InquiryItem: React.FC<{
  data: IRecommendInquiry["items"][0];
  source?: string;
  kindType?: string;
}> = ({ data, source = "PC詢價成功頁-二次詢價", kindType }) => {
  const { brandId, brandName, inquiryId, kindId, rosterId, kindName, price, thumb, showContent, type, ads } = data;

  const [params, setParams] = useSetState({
    visible: false,
    disabled: false,
    content: "",
  });
  const { visible, disabled } = params;
  const isCheckPrice = kindType === "checkPrice";

  const mutation = useMutation<void, unknown, IAgainInquiryParams>(async (params) => {
    const res = await fakeAgainInquiry(params);
    if (res?.status === 12000) {
      setParams({
        visible: true,
        disabled: true,
        content: res.data.content,
      });
      setTimeout(() => {
        setParams({
          visible: false,
        });
      }, 3000);
    } else {
      message.error(res.data.content);
    }
  });
  const content = useMemo(() => {
    if (type === "roster") {
      return <span dangerouslySetInnerHTML={{ __html: showContent }}></span>;
    }
    if (ads?.title) {
      return <span className='text-14 text-[#333]'>{ads.title?.slice(0, 10)}</span>;
    }
    return <span dangerouslySetInnerHTML={{ __html: showContent }}></span>;
  }, [type, showContent, price]);

  return (
    <>
      <Mask
        visible={visible}
        destroyOnClose={true}
        style={{ background: "unset", zIndex: 9999 }}
        onMaskClick={() => {
          setParams({
            visible: false,
          });
        }}
      >
        <>
          <div
            className={`${params.content === "詢價成功" ? "flex items-center justify-center w-200" : "w-250"
              } text-16 text-white p-14 rounded-8 bg-[#333333eb]  h-80 pt-22 text-center absolute top-[610px] left-1/2`}
            style={{ transform: "translate(-50%, -300%)" }}
            dangerouslySetInnerHTML={{ __html: params.content }}
          />
        </>
      </Mask>
      <div id={"reAskPriceItem"} className='w-160 relative'>
        <a target='_blank' className="inline-block" href={ads?.adclick || `${host.c}/photoModel-info.html?k=${kindId}`}>
          <img className='w-160 h-106' src={thumb} />
          {ads && (
            <div className='absolute top-0 left-0 '>
              <img className='w-28 h-16' src='https://photo.8891.com.tw/2024/11/08/1731055920848515.png' />
            </div>
          )}
          <div className='text-14 text-[#333] ellipsis mt-6 text-center'>
            {brandName} {kindName}
          </div>

          <div className='text-14 text-[#333] ellipsis mt-6 flex justify-center items-center'>{content}</div>
        </a>
        <div className='w-140 mx-auto'>
          <div id='inquiry-item-entry-btn'>
            <Button
              className='mt-12'
              type={isCheckPrice ? "primary" : "danger"}
              size='middle'
              block
              style={{
                "--tc-color-gray": "#fff",
                "--height": "28px",
                "--font-size": "14px",
                "--border-radius": "4px",
                "--background-color": disabled ? "#e8e8e8" : isCheckPrice && !rosterId ? "#3264FF" : "#FF4333",
              }}
              disabled={disabled}
              onClick={() => {
                const { source: querySource } = qs.parse(window.location.search, { ignoreQueryPrefix: true }) as {
                  source: string;
                };

                if (type === "roster") {
                  window.open(`/ask/price?b=${brandId}&k=${kindId}&source=${source}`, "_blank");
                  return;
                }
                mutation.mutate({
                  inquiryId: inquiryId,
                  brandId: brandId,
                  rosterId: rosterId,
                  kindId: kindId,
                  source,
                  entrance: querySource || "",
                });
              }}
            >
              {disabled ? "已詢價" : "一鍵詢價"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const initData: IRecommendInquiry = {
  items: [],
  source: "",
  kindInfo: {
    kindId: 0,
    brandId: 0,
    brandName: "",
    kindName: "",
    minimumPrice: "",
  },
  showContent: "",
  showActivityQrCode: false,
};

const ReAskPrice: React.FC<any> = () => {
  let params = qs.parse(location.search, { ignoreQueryPrefix: true }) as any;

  let { inquiryId, agreeCarResource, recommendPrice, kindType, rosterId } = params;
  const isCheckPrice = kindType === "checkPrice";

  const { data = initData } = useQuery<IRecommendInquiry>(
    [`fetchRecommendInquiry`, rosterId, inquiryId],
    async () => {
      const res = await fetchRecommendInquiry({
        inquiryId: inquiryId,
        rosterId: rosterId,
        limit: 6,
        ads: 1,
        inquiryType: kindType === "checkPrice" ? "checkPrice" : undefined,
      });
      return res?.status === 12000 ? res.data : initData;
    },
    {
      enabled: !!rosterId || !!inquiryId,
    },
  );
  const { items, kindInfo = {} } = data;

  return (
    <div className='bg-[#f5f5f5] w-full h-full'>
      <div id='ReAskPrice' className='w-1190 mx-auto pb-60'>
        {/* 面包屑 */}
        <Crumbs brandName={kindInfo?.brandName} kindName={kindInfo?.kindName} kindId={kindInfo?.kindId} />

        <div className={`w-1190 bg-white rounded-8 pb-40`}>
          <DefaultSuccessItem
            kindType={kindType}
            minimumPrice={kindInfo?.minimumPrice}
            recommendPrice={recommendPrice}
            rosterId={rosterId}
            inquiryId={inquiryId}
            brandName={kindInfo?.brandName}
            kindName={kindInfo?.kindName}
            agreeCarResource={agreeCarResource}
            data={data}
          />

          <AskSuccessLogistic rosterId={rosterId} inquiryId={inquiryId} />

          {items?.length > 0 && (
            <div className='w-1120 h-294 mx-34 rounded-8'>
              <div className='text-18 flex items-center p-20 font-medium pl-0'>
                <div className='text-[#F87F15]'>90%</div>的用戶還詢價以下車款{" "}
                <div className='ml-8 text-14 flex items-center text-[#666] font-[400]'>無需2次填寫資料</div>{" "}
              </div>
              <div className='flex gap-30 px-4'>
                {items.map((item: any, index: number) => {
                  if (item.ads) {
                    return (
                      <AdBySelfRefresh
                        data={item.ads}
                        first={true}
                        refresh={() => postInitialCollect(item.ads, "show", "")}
                        styles={{ display: "inline-block" }}
                      >
                        <InquiryItem kindType={kindType} key={index} data={item} />
                      </AdBySelfRefresh>
                    );
                  }
                  return <InquiryItem kindType={kindType} key={index} data={item} />;
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

withLayout({
  cmp: <ReAskPrice />,
  params: {
    AdTopBanner: false,
    nav: "DefaultFixedNav",
    footer: "Footer",
    needRTBH: true,
  },
});
